<template>
	<div>
		<div class="chooseBoxA">
			<div class="zimuPadding" @click="handelChooseLetter('全部')">全部</div>
			<div class="zimuAll">
				<span
					:class="{chooseBrandColor: item == chooseBrand}"
					v-for="(item, index) in brandObj"
					:key="index"
					@click="handelChooseLetter(item)"
					>{{ item }}</span
				>
			</div>
		</div>
		<div class="complex-box">
			<!-- <div
			v-if="loading"
			v-loading="loading"
			element-loading-text="拼命加载中"
			element-loading-spinner="el-icon-loading"
			class="loading-box"
		></div> -->

			<div
				v-if="!loading"
				:class="[
					opened
						? 'cotent-box unselected-body'
						: 'cotent-box unselected-body opened'
				]"
			>
				<div class="title">
					{{ searchParam.Name == "品牌" ? "车型" : searchParam.Name }} :
				</div>
				<!-- <div class="title" v-if="searchParam.Name != '品牌'">
				{{ searchParam.Name }} :
			</div>
			<div class="title" v-if="searchParam.Name == '品牌'">车型 :</div> -->
				<div class="content" v-if="list.length != 0">
					<span
						class="content-item"
						:class="{cur: item.ID == curId}"
						v-for="item in list"
						:key="item.ID"
						@click.stop="handleSelect(item, searchParam.Name)"
					>
						{{ item.Name }}
					</span>
				</div>
				<div class="content" v-if="list.length == 0">
					<span class="content-item"> 暂无 </span>
				</div>

				<div
					v-if="searchParam.Name == '品牌'"
					class="sx-box"
					:class="{opened: opened}"
					@click.stop="opened = !opened"
				>
					<span>{{ opened ? "收起筛选" : "更多品牌" }}</span>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import {BrandFamilyGroupType} from "@/api/merchant/parts"
export default {
	props: {
		searchParam: {
			type: Object,
			default: function () {
				return {
					Name: "品牌",
					ID: ""
				}
			}
		},
		searchParamBrand: {
			type: Object,
			default: function () {
				return {
					Name: "品牌",
					ID: ""
				}
			}
		},
		curId: String
	},
	watch: {
		searchParamBrand(val) {
			this.ajaxGetList(val)
		},
		searchParam(val) {
			this.ajaxGetList(val)
		}
	},

	data() {
		return {
			isAjaxFinish: true,
			loading: true,
			list: [],
			listInit: [], //list复制用来重新赋值全部
			opened: false,
			brandObj: [], //abc
			brandList: [], //分类数据
			chooseBrand: ""
			//   searchParam: {},
		}
	},
	created() {
		this.ajaxGetList(this.searchParam)
	},
	//   mounted(){
	//       document.querySelector("")
	//     this.$loading({
	//         target:
	//     })
	//   },
	methods: {
		handelChooseLetter(e) {
			this.chooseBrand = e
			(e)
			(this.brandList)
			if (e == "全部") {
				this.list = this.listInit
			} else {
				this.list = this.brandList[e]
			}
		},
		ajaxGetList(param = {}) {
			this.isAjaxFinish = false
			this.loading = true
			BrandFamilyGroupType(param)
				.then((res) => {
					this.loading = false
					this.listInit = res
					this.list = res
					this.isAjaxFinish = true
					let obj = {}
					res.reduce((obj, item) => {
						let key = item.Initial
						obj[key] ? obj[key].push(item) : (obj[key] = [item])
						return obj
					}, obj)
					let list = Object.keys(obj).sort()
					(list)
					// let strAll = "全部"
					// list.unshift(strAll)
					this.brandObj = list
					this.brandList = obj
					(list, obj)
					this.$emit("finishGetList", this.isAjaxFinish)
				})
				.catch((err) => {
					this.loading = false
				})
		},
		handleSelect(e, name) {
			(e, name)
			this.chooseBrand = e.Initial
			this.$emit("hadelSelectObj", e, name)
			const {Name} = this.searchParam
			this.$emit("select", {type: Name, id: e.ID, name: e.Name})
		}
	}
}
</script>
<style lang="scss" scoped>
.loading-box {
	text-align: center;
	font-size: 20px;
	padding: 30px;
}
.complex-box {
	padding-top: 10px;
	.cotent-box {
		display: flex;
		flex: 1;
		font-size: 16px;
		font-weight: 400;
		color: rgba(35, 35, 35, 1);
		vertical-align: text-top;
		.title {
			margin-right: 20px;
			// font-weight: 600;
		}
		.content {
			flex: 1;
			.content-item {
				// margin-right: 20px;
				// margin-bottom: 10px;
				white-space: nowrap;
				font-size: 14px;
				color: rgba(56, 56, 56, 1);
				cursor: pointer;
				&.cur {
					color: rgba(254, 118, 72, 1);
				}
			}
			display: flex;
			flex-wrap: wrap;
			grid-gap: 10px 20px;
		}
		.sx-box {
			// width: 100px;
			line-height: 1;
			cursor: pointer;
			font-size: 16px;
			font-weight: 400;
			color: rgba(35, 35, 35, 1);
			padding-right: 25px;
			position: relative;
			&::after {
				position: absolute;
				font-family: element-icons !important;
				content: "\e6df";
				font-style: normal;
				font-weight: 600;
				font-variant: normal;
				text-transform: none;
				// line-height: 1;
				display: block;
				font-size: 22px;
				color: rgba(254, 118, 72, 1);
				transition: color 0.15s linear;
				// top: 10%;
				top: 0;
				transform: translateY(-25%);
				right: 0;
			}
			&.opened {
				// padding-top: 10px;
				&::after {
					position: absolute;
					top: 10px;
					transform: translateY(-60%) rotate(180deg);
				}
			}
		}
	}
	.unselected-body {
		// background: pink;
		height: auto;
		overflow: hidden;
		word-break: break-all; //固定高度，超过直接折行，使用overflow隐藏
		// // padding-top: 10px;
		&.opened {
			height: 30px;
			opacity: 1;
			overflow: hidden;
			// border-top: 1px dashed rgba(29, 32, 137, 1);
			// // padding-top: 10px;
			// margin-bottom: 20px;
		}

		// height: 100px;
		// opacity: 1;
		// transition: 0.2s cubic-bezier(0.075, 0.82, 0.165, 1);
	}
}
.chooseBoxA {
	margin-top: 10px;
	display: flex;
	// align-items: center;
	// justify-content: space-between;
	// justify-content: space-between;
	padding: 0 19px 0 14px;
	background-color: #ebebfc;
	color: #1d2089;
	border-radius: 80px;
	height: 20px;
	// width: auto;
	font-size: 14px;
	font-weight: 400;
	vertical-align: middle;
}
.zimuPadding {
	padding-right: 14px;
	cursor: pointer;
	// width: 100%;
}
.zimuAll {
	// width: 100%;
	display: flex;
	justify-content: space-between;
	// background-color: skyblue;
	width: auto;
	flex: 1;
	cursor: pointer;
}

.chooseBrandColor {
	color: #fe7648;
}
</style>
